/**
 * Die Beschriftungen, mit denen die Art eines Prüfauftrags überall gleich heißt.
 *
 * Sie stehen an einer Stelle, weil zwei Flächen der Verwaltung dieselben vier
 * Wörter brauchen — der Warteschlangenstand an seinen Spalten und die Liste der
 * liegengebliebenen Aufträge in ihrer Zeile. Dieselbe Beschriftung an zwei Orten
 * wären zwei Wahrheiten, sobald eine davon nachgezogen wird und die andere nicht.
 *
 * Die **Schlüssel** sind die Kennungen der API und bleiben englisch (ADR-0009);
 * deutsch ist allein, was ein Mensch liest. Anders als bei den Befundarten ist die
 * Art kein Wert einer geschlossenen Menge aus dem Glossar: Sie steht so in der
 * Datenbank, und die Übersetzung gehört in die Oberfläche.
 */

import type { ReviewJobKind } from "../api/client";

export const KIND_LABELS: Record<ReviewJobKind, string> = {
  review: "Begutachtung",
  synthesis: "Synthese",
  control: "Kontrolle",
  refutation: "Widerlegung",
};
